import { render, staticRenderFns } from "./banner-main.vue?vue&type=template&id=9eeb329c&"
var script = {}
import style0 from "./banner-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports